import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-ios-install-instructions',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './ios-install-instructions.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ios-install-instructions.scss',
})
export class IosInstallInstructions {
  @Input() isOpen = false;
  @Output() onCloseDialog = new EventEmitter<void>();

  onClose(): void {
    this.onCloseDialog.emit();
  }
}
